import React, { useEffect, useRef, useState } from "react";
import Grid2 from "@mui/material/Unstable_Grid2/Grid2";
import {
  FormControlLabel,
  FormGroup,
  TextField,
  Checkbox,
  Typography,
  Button,
  Alert,
  IconButton,
  InputLabel,
  Select,
  MenuItem,
  FormControl,
} from "@mui/material";
import { styled } from "@mui/styles";
import AttachFileIcon from "@mui/icons-material/AttachFile";
import CloseIcon from "@mui/icons-material/Close";
import { toast } from "react-toastify";
import {
  registraReporte,
  fetchReporteTipos,
} from "../../redux/actions/reportes";
import { connect } from "react-redux";

const VisuallyHiddenInput = styled("input")({
  clip: "rect(0 0 0 0)",
  clipPath: "inset(50%)",
  height: 1,
  overflow: "hidden",
  position: "absolute",
  bottom: 0,
  left: 0,
  whiteSpace: "nowrap",
  width: 1,
});

const Reportes = ({
  data,
  tiposReporte,
  registraReporte,
  fetchReporteTipos,
}) => {
  let inputRef = useRef("");
  const [titulo, setTitulo] = useState("");
  const [tipoSeleccionado, setTipoSeleccionado] = useState("");
  const [detalles, setDetalles] = useState("");
  const [deshabilitado, setDeshabilitado] = useState(false);
  const [adjuntos, setAdjuntos] = useState("");
  const [previewSrc, setPreviewSrc] = useState([]);

  useEffect(() => {
    fetchReporteTipos();
  }, []);

  useEffect(() => {
    if (tiposReporte.length > 0) {
      setTipoSeleccionado(1);
    }
  }, [tiposReporte]);

  useEffect(() => {
    renderPreviews();
  }, [adjuntos]);

  const handleChangeTipo = ({ target }) => {
    setTipoSeleccionado(target.value);
  };

  const handleChangeTitulo = ({ target }) => {
    setTitulo(target.value);
  };

  const handleSetDetalles = ({ target }) => {
    setDetalles(target.value);
  };

  const handleChangeCheckbox = (event) => {
    setDeshabilitado(event.target.checked);
  };

  const handleAdjuntaFotos = ({ target }) => {
    //console.log(inputRef.current.files);
    if (adjuntos.length >= 4 || target.files.length >= 4) {
      toast.error("Solo puede adjuntar hasta 4 fotos.");
      return;
    }

    for (let i = 0; i < target.files.length; i++) {
      const imagen = target.files[i];

      if (!imagen.type.startsWith("image/")) {
        toast.error("Solo archivos de tipo imagen.");
        continue;
      }

      setAdjuntos((prev) => [...prev, imagen]);
    }
  };

  const renderPreviews = () => {
    setPreviewSrc([]);
    if (Boolean(adjuntos.length)) {
      for (let i = 0; i < adjuntos.length; i++) {
        const imagen = adjuntos[i];

        const reader = new FileReader();
        reader.onload = (e) => {
          setPreviewSrc((prev) => [...prev, e.target.result]);
        };

        reader.readAsDataURL(imagen);
      }
    }
  };

  const handleEliminaImagen = (index) => {
    const copiaPreviews = [...previewSrc];
    const copiaAdjutos = [...adjuntos];
    const nuevoPrev = copiaPreviews.splice(index, 1);
    const nuevoAdjuntos = copiaAdjutos.splice(index, 1);
    setPreviewSrc(nuevoPrev);
    setAdjuntos(copiaAdjutos);
  };

  const handleEnviaReporte = () => {
    const pistolaId = data.puesto.id;
    registraReporte(
      titulo,
      detalles,
      pistolaId,
      deshabilitado,
      tipoSeleccionado,
      adjuntos
    );
    setTitulo("");
    setDetalles("");
    setDeshabilitado(false);
    setAdjuntos("");
    setPreviewSrc([]);
  };

  return (
    <Grid2 container>
      <Grid2 md={12} xs={12}>
        {deshabilitado && data?.puesto.estado !== 5 && (
          <Alert variant="outlined" severity="warning">
            El envío de este reporte deshabilitará el puesto, podrá habilitarse
            nuevamente una vez se genere un reporte nuevo.
          </Alert>
        )}
        {data?.puesto.estado === 5 && !deshabilitado && (
          <Alert variant="outlined" severity="warning">
            El envío de este reporte habilitará el puesto nuevamente debido a su
            estado actual. Si desea mantener deshabilitado marque casilla
            'Deshabilitar Puesto'.
          </Alert>
        )}
      </Grid2>
      <Grid2 md={6} xs={12}>
        <TextField
          label="Titulo"
          fullWidth
          value={titulo}
          color="secondary"
          variant="outlined"
          onChange={handleChangeTitulo}
          inputProps={{ maxLength: 40 }}
        />
      </Grid2>
      <Grid2 md={6} xs={12}>
        <FormControl fullWidth>
          <InputLabel id="label-select">Tipo</InputLabel>
          <Select
            labelId="label-select"
            id="select-tipo"
            value={tipoSeleccionado}
            label="Tipo"
            onChange={handleChangeTipo}
            color="secondary"
          >
            {tiposReporte?.map((t) => (
              <MenuItem value={t.id} key={t.id}>
                {t.tipo}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Grid2>
      <Grid2 md={12} xs={12}>
        <TextField
          label="Detalles de Estado"
          fullWidth
          rows={4}
          value={detalles}
          color="secondary"
          variant="outlined"
          multiline
          onChange={handleSetDetalles}
          inputProps={{ maxLength: 800 }}
        />
      </Grid2>
      <Grid2 md={6} xs={12}>
        <FormControlLabel
          control={
            <Checkbox
              color="secondary"
              checked={deshabilitado}
              onChange={handleChangeCheckbox}
              inputProps={{ "aria-label": "controlled" }}
              sx={{ "& .MuiSvgIcon-root": { fontSize: 28 } }}
            />
          }
          label="Deshabilitar puesto de carga."
        />
      </Grid2>
      <Grid2 md={6} xs={12}>
        <Button
          fullWidth
          variant="outlined"
          color="secondary"
          component="label"
          role={undefined}
          tabIndex={-1}
          startIcon={<AttachFileIcon />}
          disabled={adjuntos.length >= 4}
        >
          {`Subir Imágenes (${4 - adjuntos.length})`}
          <VisuallyHiddenInput
            type="file"
            onChange={handleAdjuntaFotos}
            max={4}
            accept="image/*"
            multiple
          />
        </Button>
      </Grid2>
      {previewSrc?.map((preview, index) => (
        <Grid2 md={2} xs={4} sx={{ position: "relative" }} key={index}>
          <IconButton
            aria-label="elimina-foto-1"
            size="small"
            sx={{ position: "absolute", right: 0, bgcolor: "black" }}
            onClick={() => handleEliminaImagen(index)}
          >
            <CloseIcon fontSize="inherit" sx={{ color: "white" }} />
          </IconButton>

          <img src={preview} style={{ width: "100%", borderRadius: 13 }} />
        </Grid2>
      ))}

      <Grid2 md={12} xs={12}>
        <Button
          color="secondary"
          variant="outlined"
          fullWidth
          onClick={handleEnviaReporte}
          /* disabled={!titulo || !detalles} */
        >
          Enviar Reporte
        </Button>
      </Grid2>
    </Grid2>
  );
};

const mapStateToProps = (state) => {
  return {
    isLoading: state.global.loading,
    auth: state.auth,
    tiposReporte: state.reportes.reporteTipos,
  };
};

export default connect(mapStateToProps, { registraReporte, fetchReporteTipos })(
  Reportes
);
